export enum VariableType {
  VARIABLE = 'variable',
  GROUP = 'group',
}

interface BaseVariableApi {
  id: string;
  key: string;
  description?: string;
  created: number;
  createdAuthor: string;
  isGlobal: boolean;
  modified?: number;
  modifiedAuthor?: string;
}

export interface VariableApi extends BaseVariableApi {
  value: string;
  regexRule?: string;
}

export interface VariableGroupApi extends BaseVariableApi {
  variables: (VariableApi | VariableGroupApi)[];
}

export interface VariableCreateRequest {
  varType: VariableType.VARIABLE | VariableType.GROUP;
  workflowId?: string;
  value: {
    key: string;
    value?: string;
    description?: string;
    regexRule?: string;
  };
  parentId?: string;
}

export interface VariableUpdateRequest {
  varType: VariableType.VARIABLE | VariableType.GROUP;
  value: {
    key: string;
    value?: string;
    description?: string;
    regexRule?: string;
  };
  parentId?: string;
}

export type VariableImportItem = VariableApi | VariableGroupApi;

export interface VariableImportResponse {
  status: 'import-succeed' | 'import-failed';
  variableId: string;
  variableName: string;
  reason?: string;
}

export interface VariableDeleteRequest {
  variables: string[];
}

export const GLOBAL_WORKFLOW_ID = '00000000-0000-0000-0000-000000000000';
export const DELETE_ALL_VARIABLES_ID = '00000000-0000-0000-0000-000000000000';

export interface VariableApiError {
  code: string;
  details: Record<string, unknown>;
  id: string;
  message: string;
  title: string;
}
